import React from "react";
import { Divider } from "@mui/material";
import AttachmentViewer from "../AttachmentViewer/AttachmentViewer";
import { useSelector } from "react-redux";
import CoreSpinner from "../CoreSpinner/CoreSpinner";



const CoreDuplicate = ({ singleDoc }) => {

    const colorPrimary = useSelector((state) => state.app.primaryColor);

    return (
        <>
            {singleDoc ?
                <div>
                    <h3 className="m-0">Documento già presente</h3>
                    <p className="m-0 font-bold" style={{ color: colorPrimary }}>{singleDoc?.name}</p>
                    <Divider className="p-2" />
                    <h3>Anteprima Documento</h3>
                    <AttachmentViewer files={singleDoc?.files} />
                </div> : <CoreSpinner />

            }
        </>
    );
};

export default CoreDuplicate;
